/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
  mutation QueueDeleteMany($input: [QueueDeleteManyInput!]!) {
    QueueDeleteMany(input: $input) {
      status
      message
        items {
          kind
          vhost
          name
        status
        message
      }
    }
  }
`
